/**
 * useBranchContext
 *
 * Thin accessor hook over BranchContext. Isolated into its own hook (per
 * project convention) so components never import BranchContext directly.
 */
import { useContext } from 'react';
import { BranchContext } from '../context/branchContextInstance.js';

export const useBranchContext = () => {
  const ctx = useContext(BranchContext);
  if (!ctx) {
    throw new Error('useBranchContext must be used within a BranchProvider');
  }
  return ctx;
};
